// extracted by mini-css-extract-plugin
export default {"example":"notification_example__xxq8K"};